import React from 'react';
import PropTypes from 'prop-types';

function ADGMImage(props) {
  const { alt, name, baseURL = '/images/', httpURL, ...otherProps } = props;
  const renderImage = url => {
    return <img src={url} alt={alt} loading='lazy' decoding='async' {...otherProps} />;
  };
  return renderImage(httpURL || baseURL + name);
}

ADGMImage.propTypes = {
  classes: PropTypes.object.isRequired,
  alt: PropTypes.string.isRequired,
  baseURL: PropTypes.string,
};

export default ADGMImage;
